export enum LicensesMenuLabelEnum {
    RUNNING = 'Running licenses',
    EXPIRED = 'Expired licenses',
}
